import { resolvedBreakpoint } from './resolvedBreakpoint';

export const resolveBreakpointStyle = (key, obj) => {
    
    const resolved = resolvedBreakpoint(obj);
    
    if (resolved === null)
        return null;
    
    if (key == null)
        return resolved;
    
    return {[key]: resolved};
}